var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraphicCommunity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 168,
  height: 152
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6504"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeDasharray: "4 4",
  strokeWidth: 3,
  d: "m88.83 73.805 40.822-49.179",
  "data-name": "Path 929"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeDasharray: "4 4",
  strokeWidth: 3,
  d: "m88.876 73.842-22.275-56.6",
  "data-name": "Path 930"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeDasharray: "4 4",
  strokeWidth: 3,
  d: "m88.963 73.767-67.736-2.786",
  "data-name": "Path 931"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeDasharray: "4 4",
  strokeWidth: 3,
  d: "m88.879 73.685-25.982 59.379",
  "data-name": "Path 932"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeDasharray: "4 4",
  strokeWidth: 3,
  d: "m88.774 73.744 58.447 33.4",
  "data-name": "Path 933"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M62.296 24.755v-3.4c-.1-.1-.1-.1-.207-.2v-.207a2.9 2.9 0 0 0 .7.808l2.692 1.9a1.654 1.654 0 0 0 2.092 0l2.485-2.2c.1-.1.2-.1.3-.207v3.5a.87.87 0 0 0 .1.5h-8.17c-.096-.193.008-.297.008-.494",
  "data-name": "Path 939"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M81.418 85.54v-5.457l-.321-.321v-.321a4.5 4.5 0 0 0 1.118 1.284l4.329 3.055a2.67 2.67 0 0 0 3.366 0l4.018-3.542c.155-.155.321-.155.476-.321v5.623a1.43 1.43 0 0 0 .166.808H81.418c-.166-.321 0-.487 0-.808",
  "data-name": "Path 945"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M126.085 29.167v-2.175l-.124-.124v-.124a1.6 1.6 0 0 0 .445.507l1.719 1.212a1.05 1.05 0 0 0 1.336 0l1.584-1.4c.072-.073.135-.073.2-.135v2.237a.6.6 0 0 0 .062.321h-5.219c-.065-.132-.003-.195-.003-.319",
  "data-name": "Path 951"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M24.096 76.733v2.465l-7.384.228.352-1.636c.114 0 .114.114.228.114.238.114.476.352.7.466a1.5 1.5 0 0 0 .466.352.12.12 0 0 1 .124.124V77.2l-.124-.114c1.294.703 3.059 1.169 5.638-.353",
  "data-name": "Path 955"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M63.928 140.375v1.978l-5.913.186.28-1.315c.093 0 .093.093.186.093.2.093.383.28.57.373a1.3 1.3 0 0 0 .373.28.1.1 0 0 1 .093.1v-1.326l-.093-.093a4.14 4.14 0 0 0 4.504-.276",
  "data-name": "Path 961"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150.762 113.756v2.651l-7.922.249.383-1.76c.124 0 .124.124.249.124.249.124.5.383.756.507a1.7 1.7 0 0 0 .5.373s.135 0 .135.124v-1.76l-.135-.124c1.384.755 3.272 1.262 6.034-.384",
  "data-name": "Path 967"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6505"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M139.914 25.033a11.02 11.02 0 0 1-3.528 8.08 10.6 10.6 0 0 1-1.968 1.431 11.12 11.12 0 0 1-11.126 0 4.8 4.8 0 0 1-.746-.479 11.02 11.02 0 1 1 17.367-9.032Z",
  "data-name": "Path 1343"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6491"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eec9ae",
  d: "M126.617 26.48a3.4 3.4 0 0 0 .475.473c.135.137.271.2.407.341.068.066.2.137.271.2a.066.066 0 0 1 .068.066l.068.071v.946l-.068-.066c-.068-.066-.2-.138-.271-.2-.136-.066-.271-.2-.407-.27-.068 0-.068-.071-.136-.071-.475-.27-.882-.539-.882-.88a2.4 2.4 0 0 1 .475-.61m9.437 5.253a4.3 4.3 0 0 0-1.907-2.2 4.1 4.1 0 0 0-1.56-.407h-.678c-.746-.065-.814-.2-.814-.2v-1.562a12.5 12.5 0 0 0 1.357-1.359 4.3 4.3 0 0 0 .746-1.694 1.22 1.22 0 0 0 .95-1.359c0-.269-.2-.544-.2-.814v-.952a4.8 4.8 0 0 0-.475-1.5 4.58 4.58 0 0 0-4.07-2.442 5 5 0 0 0-1.018.137 3.9 3.9 0 0 0-1.7.814 1 1 0 0 0-.272.27l-.068.072a4.33 4.33 0 0 0-1.221 1.9 5.1 5.1 0 0 0-.2 2.244v.132c0 .137.068.137 0 .2 0 .071-.068.071-.068.137a.94.94 0 0 0-.068.881c.271.682.678.616 1.153.951a.07.07 0 0 0-.068.072l-.475.132c-2.171.682-2.917 2.514-1.967 3.669a3.1 3.1 0 0 0 1.7.952.83.83 0 0 0-.542.269 4.66 4.66 0 0 0-1.7 2.987v.2c.271.137.475.341.746.478l10.623-.253a9.2 9.2 0 0 0 1.589-1.265c-.071-.33.275-.424.207-.489Z",
  "data-name": "Path 1344"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#565d69",
  d: "M136.386 32.113a10.6 10.6 0 0 1-1.968 1.43 11.12 11.12 0 0 1-11.126 0 4.8 4.8 0 0 1-.746-.478v-.2a4.66 4.66 0 0 1 1.7-2.987 1.3 1.3 0 0 1 .543-.27 2.48 2.48 0 0 1-1.7-.952h2.578a3.95 3.95 0 0 0 3.256 1.628 4.1 4.1 0 0 0 2.917-1.221h.678a3.2 3.2 0 0 1 1.561.407 4.8 4.8 0 0 1 2.1 2.239c.135.134.135.272.207.404",
  "data-name": "Path 1345"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c4af6e",
  d: "M133.944 21.422a6.9 6.9 0 0 1-2.646.341 6.8 6.8 0 0 1-3.867-1.629 4.02 4.02 0 0 1-2.239 2.239.9.9 0 0 1-.407.138v-.066a5.1 5.1 0 0 1 .2-2.244 4.34 4.34 0 0 1 1.221-1.9l.068-.072c.068-.066.2-.132.272-.27a3.9 3.9 0 0 1 1.7-.814 5 5 0 0 1 1.018-.138 4.5 4.5 0 0 1 4.07 2.442 5.4 5.4 0 0 1 .475 1.5.97.97 0 0 1 .135.473",
  "data-name": "Path 1347"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#c4af6e",
  d: "M128.517 31.502a2.1 2.1 0 0 1-1.7.479c.611-.611.271-2.58-1.9-2.376-2.985-.545-2.714-3.669.271-4.621l.475-.132.068.066a5 5 0 0 0 .882 1.563c-1.221 1.017.475 1.287 1.289 2.1.683.413 1.294 2.108.615 2.921",
  "data-name": "Path 1348"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M139.914 25.033a11.02 11.02 0 0 1-3.528 8.08 10.6 10.6 0 0 1-1.968 1.431 11.12 11.12 0 0 1-11.126 0 4.8 4.8 0 0 1-.746-.479 11.02 11.02 0 1 1 17.367-9.032Z",
  "data-name": "Path 5457"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6506"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M82.972 17.915a17.18 17.18 0 0 1-17.1 17.121 17.077 17.077 0 0 1-17-17.013 17.052 17.052 0 0 1 34.1-.107Z",
  "data-name": "Path 1338"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#855d40",
  d: "M78.291 29.636a2.7 2.7 0 0 1-.815.71A16.91 16.91 0 0 1 56.2 31.881a20 20 0 0 1-2.24-1.841 5.25 5.25 0 0 1 2.341-1.321l.509-.207c1.018-.4 2.443-.916 4.275-1.733a1.84 1.84 0 0 0 .713-.5.55.55 0 0 0 .2-.413 1.8 1.8 0 0 0 .2-.71v-3.469l-.2-.2a2.54 2.54 0 0 1-.509-1.535l-.2-.1c-.916.207-.815-.71-1.018-2.551-.1-.71 0-.917.407-1.015l.305-.4a10.1 10.1 0 0 1-.916-3.773 3.48 3.48 0 0 1 1.731-3.36 4.7 4.7 0 0 1-.611-1.635 24.6 24.6 0 0 0 4.785.413c1.527-.313 3.971.1 4.886 2.138a3.23 3.23 0 0 1 2.24 2.542c.2 1.634-.713 3.368-.916 4.078v.1c.2.107.305.306.2 1.024-.2 1.734-.2 2.749-1.018 2.543l-.815 1.428c0 .206 0 .206-.1.305v3.566a1.4 1.4 0 0 0 .305.916c.1.107.1.207.2.207.2.206.407.4.611.4 2.036.817 3.461 1.428 4.581 1.841a10.5 10.5 0 0 1 2.145 1.017",
  "data-name": "Path 1339"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35df90",
  d: "M78.29 29.636a2.7 2.7 0 0 1-.814.71 16.91 16.91 0 0 1-21.277 1.535 20 20 0 0 1-2.24-1.841 5.26 5.26 0 0 1 2.341-1.321l.509-.206c1.018-.4 2.443-.916 4.275-1.734a1.84 1.84 0 0 0 .713-.5 5.54 5.54 0 0 0 4.581 2.344 5.68 5.68 0 0 0 4.479-2.245c.2.206.408.4.611.4 2.036.817 3.461 1.428 4.581 1.841a9.5 9.5 0 0 1 2.241 1.017",
  "data-name": "Path 1340"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313844",
  d: "M72.124 16.147a2.04 2.04 0 0 0-.349-1.337c0-.1-.1-.1-.1-.2a4.17 4.17 0 0 0-3.664-2.039c-3.767-.206-4.072.5-5.192-.512a2.19 2.19 0 0 1-.2 2.444 3 3 0 0 1-1.832 1.329c-1.731-3.872-1.967-6.964.634-9.092s11.18-.887 11.86 2.717c1.195 2.983-.954 5.975-1.157 6.69",
  "data-name": "Path 1341"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#855d40",
  d: "M62.306 25.154v-3.467l-.2-.2v-.206a2.8 2.8 0 0 0 .713.817l2.748 1.932a1.68 1.68 0 0 0 2.138 0l2.545-2.237c.1-.108.2-.108.305-.207v3.566a.92.92 0 0 0 .1.512h-8.348c-.103-.205-.001-.304-.001-.51",
  "data-name": "Path 1342"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M82.972 17.915a17.18 17.18 0 0 1-17.1 17.121 17.077 17.077 0 0 1-17-17.013 17.052 17.052 0 0 1 34.1-.107Z",
  "data-name": "Path 5458"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6507"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M39.411 70.782a19.14 19.14 0 0 1-6.127 14.035 18.4 18.4 0 0 1-3.417 2.484 19.32 19.32 0 0 1-19.323 0 8 8 0 0 1-1.3-.831 19.14 19.14 0 1 1 30.163-15.687Z",
  "data-name": "Path 1343"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6491"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#cfba89",
  d: "M16.318 75.032a6 6 0 0 0 .825.822c.235.239.471.354.707.592.118.115.354.239.471.354a.114.114 0 0 1 .118.115l.117.124v1.644l-.117-.115c-.118-.114-.354-.239-.471-.354-.236-.115-.471-.353-.707-.468-.117 0-.117-.124-.236-.124-.825-.468-1.532-.937-1.532-1.529a4.2 4.2 0 0 1 .825-1.061m16.391 9.124a7.47 7.47 0 0 0-3.312-3.822 7.1 7.1 0 0 0-2.71-.707h-1.178c-1.3-.114-1.414-.353-1.414-.353v-2.713a22 22 0 0 0 2.356-2.36 7.5 7.5 0 0 0 1.3-2.943 2.12 2.12 0 0 0 1.649-2.36c0-.468-.354-.946-.354-1.414v-1.653a8.3 8.3 0 0 0-.825-2.6 7.96 7.96 0 0 0-7.069-4.242 8.6 8.6 0 0 0-1.767.239 6.8 6.8 0 0 0-2.946 1.414 1.8 1.8 0 0 0-.472.468l-.118.124a7.5 7.5 0 0 0-2.121 3.3 8.8 8.8 0 0 0-.354 3.9v.229c0 .239.119.239 0 .353 0 .124-.117.124-.117.239a1.63 1.63 0 0 0-.117 1.529c.471 1.185 1.178 1.07 2 1.653a.117.117 0 0 0-.117.124l-.825.229c-3.77 1.185-5.066 4.366-3.417 6.373a5.4 5.4 0 0 0 2.946 1.653 1.44 1.44 0 0 0-.942.468 8.1 8.1 0 0 0-2.946 5.188v.354c.471.239.825.592 1.3.831l18.449-.446a16 16 0 0 0 2.76-2.2c-.122-.578.478-.74.361-.855",
  "data-name": "Path 1344"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ff8700",
  d: "M33.284 84.817a18.4 18.4 0 0 1-3.418 2.484 19.32 19.32 0 0 1-19.323 0 8 8 0 0 1-1.3-.831v-.354a8.1 8.1 0 0 1 2.946-5.187 2.3 2.3 0 0 1 .943-.469 4.3 4.3 0 0 1-2.946-1.653h4.478a6.87 6.87 0 0 0 5.655 2.828 7.1 7.1 0 0 0 5.067-2.121h1.178a5.5 5.5 0 0 1 2.711.707 8.33 8.33 0 0 1 3.652 3.889c.24.238.24.477.357.707",
  "data-name": "Path 1345"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313844",
  d: "M29.043 66.247a12 12 0 0 1-4.6.593 11.84 11.84 0 0 1-6.716-2.829 7 7 0 0 1-3.889 3.889 1.6 1.6 0 0 1-.707.239v-.114a8.8 8.8 0 0 1 .354-3.9 7.54 7.54 0 0 1 2.121-3.3l.118-.125c.118-.115.354-.229.472-.468a6.8 6.8 0 0 1 2.946-1.414 8.6 8.6 0 0 1 1.767-.239 7.82 7.82 0 0 1 7.069 4.242 9.3 9.3 0 0 1 .824 2.6 1.7 1.7 0 0 1 .241.826",
  "data-name": "Path 1347"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313844",
  d: "M19.616 83.756c-.707.831-1.885.831-2.946.831 1.06-1.061.471-4.481-3.3-4.128-5.184-.946-4.713-6.372.471-8.025l.826-.229.117.114a8.6 8.6 0 0 0 1.532 2.713c-2.121 1.767.825 2.236 2.239 3.65 1.179.713 2.238 3.66 1.061 5.074",
  "data-name": "Path 1348"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M39.411 70.782a19.14 19.14 0 0 1-6.127 14.035 18.4 18.4 0 0 1-3.417 2.484 19.32 19.32 0 0 1-19.323 0 8 8 0 0 1-1.3-.831 19.14 19.14 0 1 1 30.163-15.687Z",
  "data-name": "Path 5459"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6508"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M167 108.069a20.43 20.43 0 0 1-6.54 14.981 19.6 19.6 0 0 1-3.648 2.651 20.62 20.62 0 0 1-20.625 0 9 9 0 0 1-1.383-.887 20.43 20.43 0 1 1 32.2-16.745Z",
  "data-name": "Path 1343"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6491",
  transform: "translate(134.804 95.05)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#eec9ae",
  d: "M25.041 27.295a7.97 7.97 0 0 0-3.536-4.079 7.6 7.6 0 0 0-2.892-.755h-1.257c-1.384-.122-1.509-.377-1.509-.377v-2.9a23 23 0 0 0 2.515-2.519 8 8 0 0 0 1.384-3.141 2.59 2.59 0 0 0 1.977-2.67c-.2-1.25-.594-.424-.594-.924v-2.2a8.9 8.9 0 0 0-.88-2.774A8.49 8.49 0 0 0 12.704.428a9.2 9.2 0 0 0-1.887.255 7.24 7.24 0 0 0-3.144 1.509 2 2 0 0 0-.5.5l-.125.133a8.03 8.03 0 0 0-2.264 3.518 9.4 9.4 0 0 0-.377 4.161v.122l-.316-.292c-1.017.326-.453 2.967 1.5 3.189a11.85 11.85 0 0 0 2.7 5.138 14.2 14.2 0 0 1 0 3.158c-.147.827-3.012.661-2.509.916l15.927 7.818a17 17 0 0 0 2.946-2.345c-.129-.617.511-.791.386-.913",
  "data-name": "Path 1344"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#35df90",
  d: "M25.656 28a19.6 19.6 0 0 1-3.648 2.651 20.62 20.62 0 0 1-20.625 0A8.7 8.7 0 0 1 0 29.764v-.377a8.64 8.64 0 0 1 3.144-5.537 9.7 9.7 0 0 1 3.151-1.338 9 9 0 0 0 5.526 2.092 7.58 7.58 0 0 0 5.408-2.264h1.257a5.9 5.9 0 0 1 2.893.754 8.9 8.9 0 0 1 3.9 4.151c.252.255.252.51.377.755",
  "data-name": "Path 1345"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757b87",
  d: "M9.317 7.747a12.64 12.64 0 0 0 7.055-3.267 7.46 7.46 0 0 0 4.292 4.002 1.7 1.7 0 0 0 .764.228l-.005-.122a9.4 9.4 0 0 0-.522-4.144 8.04 8.04 0 0 0-2.385-3.435l-.13-.128c-.13-.118-.384-.232-.516-.482A7.24 7.24 0 0 0 14.676-1a9.2 9.2 0 0 0-1.894-.188A8.35 8.35 0 0 0 5.402 3.6a10 10 0 0 0-.782 2.801c-.238.509 3.064 1.525 4.697 1.346",
  "data-name": "Path 1347"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "#757b87",
  "data-name": "Ellipse 320",
  transform: "translate(10.195 -2.882)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M167 108.069a20.43 20.43 0 0 1-6.54 14.981 19.6 19.6 0 0 1-3.648 2.651 20.62 20.62 0 0 1-20.625 0 9 9 0 0 1-1.383-.887 20.43 20.43 0 1 1 32.2-16.745Z",
  "data-name": "Path 5459"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6509"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M76.611 135.566a15.5 15.5 0 0 1-15.418 15.433 15.393 15.393 0 0 1-15.325-15.336 15.372 15.372 0 0 1 30.743-.1Z",
  "data-name": "Path 1332"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2b695",
  d: "M72.39 146.134a2.4 2.4 0 0 1-.734.64 15.23 15.23 0 0 1-19.179 1.377 17 17 0 0 1-2.019-1.652 4.67 4.67 0 0 1 2.11-1.191l.459-.186c.918-.365 2.2-.826 3.854-1.563a1.66 1.66 0 0 0 .643-.454.5.5 0 0 0 .183-.372 1.7 1.7 0 0 0 .184-.64v-3.125c-.092-.089-.092-.089-.184-.186a2.25 2.25 0 0 1-.454-1.378l-.184-.089c-.826.186-.734-.647-.918-2.3-.092-.64 0-.826.367-.916l.275-.372a9.05 9.05 0 0 1-.826-3.393 3.15 3.15 0 0 1 1.56-3.036 4.2 4.2 0 0 1-.551-1.466 21.7 21.7 0 0 0 4.313.365c1.377-.275 3.579.1 4.4 1.935a2.91 2.91 0 0 1 2.019 2.292 8.7 8.7 0 0 1-.825 3.676v.089c.183.1.275.275.183.923-.183 1.555-.183 2.478-.917 2.292l-.734 1.288c0 .186 0 .186-.092.275v3.215a1.3 1.3 0 0 0 .275.826c.092.1.092.186.184.186.183.186.367.365.551.365 1.835.737 3.12 1.287 4.129 1.652a9.8 9.8 0 0 1 1.928.923",
  "data-name": "Path 1333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#565d69",
  d: "M72.39 146.189a2.4 2.4 0 0 1-.734.64 15.23 15.23 0 0 1-19.179 1.377 17 17 0 0 1-2.019-1.652 4.67 4.67 0 0 1 2.11-1.191l.459-.186c.918-.365 2.2-.826 3.854-1.562a1.66 1.66 0 0 0 .643-.454 5.01 5.01 0 0 0 4.129 2.106 5.13 5.13 0 0 0 4.038-2.017c.184.186.368.365.551.365 1.836.737 3.12 1.287 4.13 1.652a8.8 8.8 0 0 1 2.018.922",
  "data-name": "Path 1334"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#746052",
  d: "M67 134.012a1.82 1.82 0 0 0-.28-1.22c0-.091-.093-.091-.093-.19a3.86 3.86 0 0 0-3.366-1.873c-3.459-.182-3.739.47-4.768-.462a2.01 2.01 0 0 1-.187 2.244 2.73 2.73 0 0 1-1.683 1.213c-1.589-3.556-.748-5.8.748-6.551a4.3 4.3 0 0 1-.561-1.493 22 22 0 0 0 4.394.371c1.4-.281 3.647.1 4.488 1.971a2.97 2.97 0 0 1 2.057 2.335c.279 1.403-.561 2.993-.749 3.655",
  "data-name": "Path 1335"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e2b695",
  d: "M57.983 142.135v-3.126c-.091-.089-.091-.089-.184-.186v-.178a2.4 2.4 0 0 0 .643.729l2.477 1.749a1.515 1.515 0 0 0 1.927 0l2.294-2.024c.092-.089.184-.089.275-.178v3.215a.8.8 0 0 0 .092.454h-7.525c-.091-.18.001-.277.001-.455",
  "data-name": "Path 1336"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M76.611 135.566a15.5 15.5 0 0 1-15.418 15.433 15.393 15.393 0 0 1-15.325-15.336 15.372 15.372 0 0 1 30.743-.1Z",
  "data-name": "Path 5460"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 6510"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f6f7fb",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M114.684 74.697a27.64 27.64 0 0 1-27.495 27.523 27.45 27.45 0 0 1-27.33-27.35 27.413 27.413 0 0 1 54.825-.173Z",
  "data-name": "Path 1332"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cfae89",
  d: "M107.157 93.542a4.3 4.3 0 0 1-1.31 1.141 27.16 27.16 0 0 1-34.2 2.456 30.5 30.5 0 0 1-3.6-2.946c.654-.81 1.636-1.314 3.763-2.124l.819-.332c1.636-.65 3.927-1.473 6.873-2.787a2.96 2.96 0 0 0 1.147-.809.88.88 0 0 0 .326-.663 3.1 3.1 0 0 0 .328-1.141v-5.574c-.163-.159-.163-.159-.328-.332a4 4 0 0 1-.817-2.455l-.328-.159c-1.473.332-1.31-1.154-1.636-4.1-.165-1.142 0-1.474.654-1.633l.491-.664a16.1 16.1 0 0 1-1.473-6.05c0-2.788 1.145-4.592 2.783-5.415a7.6 7.6 0 0 1-.982-2.614s5.728.981 7.692.65c2.455-.491 6.382.173 7.855 3.45a5.19 5.19 0 0 1 3.6 4.087c.328 2.628-1.145 5.4-1.472 6.556v.159c.326.173.491.491.326 1.646-.326 2.774-.326 4.419-1.636 4.087l-1.31 2.3c0 .332 0 .332-.163.491V86.5a3.8 3.8 0 0 0 .491 1.473c.163.173.163.332.328.332.327.332.654.65.982.65 3.272 1.314 5.564 2.3 7.364 2.946a17.4 17.4 0 0 1 3.433 1.641",
  "data-name": "Path 1333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#186b74",
  d: "M107.157 93.64a4.3 4.3 0 0 1-1.31 1.141 27.16 27.16 0 0 1-34.2 2.456 30.4 30.4 0 0 1-3.6-2.946c.654-.81 1.636-1.314 3.763-2.123l.819-.332c1.636-.65 3.927-1.473 6.873-2.787a3 3 0 0 0 1.147-.81 8.93 8.93 0 0 0 7.364 3.756 9.15 9.15 0 0 0 7.2-3.6c.328.333.656.65.982.65 3.274 1.314 5.564 2.3 7.365 2.946a15.7 15.7 0 0 1 3.597 1.649",
  "data-name": "Path 1334"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313844",
  d: "M97.545 71.924a3.25 3.25 0 0 0-.5-2.177c0-.163-.166-.163-.166-.338-1.167-2.326-3.668-3.164-6-3.339-6.169-.325-6.668.838-8.5-.825.667.825.667 2.339-.334 4a4.87 4.87 0 0 1-3 2.163c-2.834-6.341-1.333-10.343 1.335-11.681a7.7 7.7 0 0 1-1-2.663s5.836 1 7.837.662c2.5-.5 6.5.177 8 3.516a5.29 5.29 0 0 1 3.668 4.164c.494 2.503-1.007 5.341-1.34 6.518",
  "data-name": "Path 1335"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#cfae89",
  d: "M81.466 86.41v-5.574c-.163-.158-.163-.158-.328-.331v-.318a4.3 4.3 0 0 0 1.147 1.3l4.418 3.119a2.7 2.7 0 0 0 3.437 0l4.091-3.61c.165-.16.328-.16.491-.318v5.732a1.44 1.44 0 0 0 .165.809H81.466c-.165-.323 0-.491 0-.809",
  "data-name": "Path 1336"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#d6dce8",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M114.684 74.697a27.64 27.64 0 0 1-27.495 27.523 27.45 27.45 0 0 1-27.33-27.35 27.413 27.413 0 0 1 54.825-.173Z",
  "data-name": "Path 5460"
})))));
export default SvgGraphicCommunity;